import { render, staticRenderFns } from "./GStudentRecordGrowthAdvice.vue?vue&type=template&id=40783004&scoped=true&"
import script from "./GStudentRecordGrowthAdvice.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordGrowthAdvice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40783004",
  null
  
)

export default component.exports